// extracted by mini-css-extract-plugin
export default {"financeFeesEditorContainer":"_finance-fees-editor_financeFeesEditorContainer__hfHFy"};